import React from "react";
import { eventoColor } from "../lib/eventiSanitari";

const LEGACY_RE = /^\[Evento sanitario · ([^\]]+)\]\s*/;

export function EventoTitolo({ c }) {
  if (!c.evento_titolo) return null;
  return <div className="text-xs font-bold mb-0.5" style={{ color: eventoColor(c.evento_tipo).txt }} data-testid="consegna-evento-titolo">[{c.evento_titolo}]</div>;
}

export function ConsegnaTesto({ c, className = "text-sm whitespace-pre-wrap leading-relaxed" }) {
  const legacy = !c.evento_titolo && LEGACY_RE.exec(c.testo || "");
  const titolo = c.evento_titolo || (legacy ? `Evento sanitario · ${legacy[1]}` : "");
  if (!titolo) return <p className={className}>{c.testo}</p>;
  const testo = legacy ? (c.testo || "").replace(LEGACY_RE, "") : c.testo;
  return (
    <div data-testid="consegna-evento">
      <div className="text-xs font-bold mb-0.5" style={{ color: eventoColor(c.evento_tipo).txt }} data-testid="consegna-evento-titolo">[{titolo}]</div>
      <p className={`${className} font-head font-bold text-base`}>{testo}</p>
    </div>
  );
}
